import type { LogoutRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useLogout() {
	return useApiMutation(
		"post",
		"/auth/logout",
		{
			notify: false,
			mapVariables: (data: LogoutRequestDto) => ({
				body: data,
				headers: {
					"x-auth-request": "true",
				},
				credentials: "include",
			}),
		},
	);
}
